import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateSubtitle,
  EmptyStateTitle,
} from './styled';

export const CustomNoRowsOverlay: React.FC = () => {
  const { t } = useTranslation('activityLog');

  return (
    <EmptyStateContainer>
      <EmptyStateIcon iconName="Plant" useMuiSvgIcon={false} />
      <EmptyStateTitle variant="h4">
        {t('emptyState.firstTradeTitle')}
      </EmptyStateTitle>
      <EmptyStateSubtitle variant="h4">
        {t('emptyState.firstStepTitle')}
      </EmptyStateSubtitle>
    </EmptyStateContainer>
  );
};
